// extracted by mini-css-extract-plugin
module.exports = {"root":"radio-indicator_root__pg7D9","show":"radio-indicator_show__YiE3m"};